<template>
  <section class="init_box" style="background-color: white">
    <!-- 搜索区域 -->
    <el-row type="flex" justify="end" style="flex-wrap: wrap; flex-direction: row">
      <el-col :span="24"
        style="margin-top: 15px;display: flex; flex-wrap: wrap; gap: 10px 0px; align-items: flex-start; align-content: flex-start;">
      </el-col>
    </el-row>
    <el-row style="margin-top: 15px; flex-wrap: wrap; flex-direction: row" type="flex" justify="end">
      <el-col :span="19">
        <el-form :inline="true" :model="searchForm" style="float: right">
          <el-form-item label="设备名称">
            <el-input v-model="searchForm.deviceName" placeholder="请输入设备名称" clearable style="width: 200px"></el-input>
          </el-form-item>
          <el-form-item label="管理编号">
            <el-input v-model="searchForm.manageCode" placeholder="请输入管理编号" clearable style="width: 200px"></el-input>
          </el-form-item>
          <el-form-item label="操作人">
            <el-input v-model="searchForm.operatorName" placeholder="请输入操作人" clearable style="width: 150px"></el-input>
          </el-form-item>
          <el-form-item label="变更时间">
            <el-date-picker
              v-model="searchForm.dateRange"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              style="width: 240px">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" @click="handleSearch">查询</el-button>
            <el-button size="small" @click="handleReset">重置</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>

    <!-- 表格区域 -->
    <el-row style="margin-top: 5px">
      <el-col :span="24">
        <el-table
          :data="historyList"
          v-loading="loading"
          :header-cell-style="{ background: '#eff3f6' }"
          stripe
          border
          height="600"
          style="width: 99%; margin: 0px auto; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
          <el-table-column type="index" label="序号" width="80" align="center"></el-table-column>
          <el-table-column prop="deviceName" label="设备名称" min-width="150" show-overflow-tooltip></el-table-column>
          <el-table-column prop="manageCode" label="管理编号" width="120" show-overflow-tooltip></el-table-column>
          <el-table-column prop="oldDeptName" label="原使用部门" min-width="120" show-overflow-tooltip></el-table-column>
          <el-table-column prop="newDeptName" label="新使用部门" min-width="120" show-overflow-tooltip></el-table-column>
          <el-table-column prop="operatorName" label="操作人" width="100" align="center"></el-table-column>
          <el-table-column prop="changeTime" label="变更时间" width="160" align="center">
            <template slot-scope="scope">
              {{ scope.row.changeTime | formatDate }}
            </template>
          </el-table-column>
          <el-table-column prop="remark" label="备注" min-width="150" show-overflow-tooltip></el-table-column>
        </el-table>

        <!-- 分页 -->
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageIndex"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          style="margin-top: 20px; text-align: right">
        </el-pagination>
      </el-col>
    </el-row>
  </section>
</template>

<script>
import { getDeviceDeptChangeHistoryList } from '@/api/api'

export default {
  name: 'DeviceDeptChangeHistory',
  data() {
    return {
      searchForm: {
        deviceName: '',
        manageCode: '',
        operatorName: '',
        dateRange: []
      },
      historyList: [],
      loading: false,
      pageIndex: 1,
      pageSize: 20,
      total: 0
    }
  },
  filters: {
    formatDate(value) {
      if (!value) return ''
      const date = new Date(value)
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      const seconds = String(date.getSeconds()).padStart(2, '0')
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    loadData() {
      this.loading = true
      const params = {
        deviceName: this.searchForm.deviceName,
        manageCode: this.searchForm.manageCode,
        operatorName: this.searchForm.operatorName,
        startDate: this.searchForm.dateRange ? this.searchForm.dateRange[0] : '',
        endDate: this.searchForm.dateRange ? this.searchForm.dateRange[1] : '',
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      }
      
      getDeviceDeptChangeHistoryList(params).then((res) => {
        this.loading = false
        if (res.status === 200) {
          this.historyList = res.data.list || []
          this.total = res.data.total || 0
        } else {
          this.$message.error(res.message || '查询失败')
        }
      }).catch((err) => {
        this.loading = false
        this.$message.error('网络错误，请重试')
        console.error('查询变更历史错误:', err)
      })
    },
    handleSearch() {
      this.pageIndex = 1
      this.loadData()
    },
    handleReset() {
      this.searchForm = {
        deviceName: '',
        manageCode: '',
        operatorName: '',
        dateRange: []
      }
      this.pageIndex = 1
      this.loadData()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.loadData()
    },
    handleCurrentChange(val) {
      this.pageIndex = val
      this.loadData()
    }
  }
}
</script>

<style scoped>
.change-history-container {
  padding: 20px;
}
.box-card {
  min-height: calc(100vh - 100px);
}
</style>



// WEBPACK FOOTER //
// src/views/device/DeviceDeptChangeHistory.vue